// AUTOGENERATED by ci-scripts/build_branding_assets.py — do not edit.
// Regenerated on every `npm run dev` / `npm run build`.
export const CONFIG = Object.freeze({
  "api": {
    "base_url": "https://api.prod.flapanthersgameday.com",
    "create_user_privacy_request_path": "/create-user-privacy-request"
  },
  "branding": {
    "app_title": "Florida Panthers Gameday Data Management",
    "brand_name": "Florida Panthers Gameday",
    "brand_subtitle": "Data Management",
    "colors": {
      "accent": "#CF102D",
      "fg": "#FFFFFF",
      "page_bg": "#000000",
      "primary": "#091F3F",
      "secondary": "#BD965C"
    },
    "delete_account_final_confirm": "Final Confirmation:\n\nProceed with deleting your Florida Panthers GameDay Account? This action can not be undone.",
    "delete_account_first_confirm": "Are you sure you wish to delete your Florida Panthers GameDay account? Any points, rewards, or eCash will be lost and not recoverable.\n\nIf you proceed, you will be immediately logged out, your account disabled, and you will not be able to make further requests for this account.",
    "email_placeholder": "example@FloridaPanthers.com",
    "legal_footer": "Panthers Gameday \u00a9 2025 Brightest Day Labs, LLC. All Rights Reserved.",
    "login_label": "Email used for Panthers Gameday account:"
  },
  "cognito": {
    "app_client_id": "5i2ainkps4aen45d2jtu4beqjd",
    "region": "us-east-1",
    "user_pool_id": "us-east-1_uDFMvHEjO"
  },
  "domain": "flapanthersgameday.com",
  "env": "prod",
  "envColor": "#37474f",
  "envName": "PROD",
  "league": "nhl",
  "team": "fla"
});
